// extracted by mini-css-extract-plugin
export var equalColumn = "_ha-0";